/**
 * Service for fetching reports from the API
 */

const REPORTS_API_URL = 'https://eva-retrieve-reports-1057220697534.us-central1.run.app/get_reports';

/**
 * Fetches reports from the API
 * @param {string} authToken - Authentication token
 * @param {string} userEmail - Optional user email
 * @returns {Promise<Array>} Array of reports with report_title, report_body, and created_at
 */
export const fetchReports = async (authToken, userEmail = null) => {
  try {
    // Prepare payload - include user email if available
    const payload = {};
    if (userEmail) {
      payload.user_email_id = userEmail;
    }

    const response = await fetch(REPORTS_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    
    // Handle both array and object responses
    if (Array.isArray(data)) {
      return data;
    } else if (data.reports && Array.isArray(data.reports)) {
      return data.reports;
    } else if (data.data && Array.isArray(data.data)) {
      return data.data;
    } else {
      // If response is not in expected format, return empty array
      console.warn('Unexpected API response format:', data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching reports:', error);
    throw new Error(error.message || 'Failed to fetch reports');
  }
};

const reportsService = {
  fetchReports,
};

export default reportsService;

